<app-loading-indicator [isLoading]="isLoading$ | async"></app-loading-indicator>
<router-outlet></router-outlet>
